import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FanOrderPaymentHistoryModel } from '../../api';

@Component({
    selector: 'fan-payment-overview',
    templateUrl: './payment-overview.component.html',
    standalone: false
})
export class PaymentOverviewComponent implements OnInit {

  constructor(private translate: TranslateService) { }

  orderId: number = null;

  pagedHistoryLines = [];
  lastUsedPageHistory = null;
  orderPaymentHistory : Array<FanOrderPaymentHistoryModel> = null;

  @ViewChild('historyPagerComponent') historyPagerComponent;

  ngOnInit() {
  }

  doHistoryPage(pageArgs) {
    this.setHistoryPage(pageArgs.pageNr);
  }


  setHistoryPage(pageNr: number) {
    this.lastUsedPageHistory = pageNr;
    const length = this.orderPaymentHistory.length; //we need a copy
    this.historyPagerComponent.setObjectCount(length);
    this.pagedHistoryLines = this.orderPaymentHistory.slice((pageNr - 1) * this.historyPagerComponent.pageSize, (pageNr) * this.historyPagerComponent.pageSize);
    this.historyPagerComponent.setPage (pageNr);
  }

  getPaymentStatusText(status) {
    switch (status) {
      case 1: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.OK');
      case 2: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.CANCELLED');
      case 3: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.FAILED');
      case 4: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.DECLINED');
      case 5: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.PENDING');
      case 6: return this.translate.instant('FAN.PAYMENT-OVERVIEW.HEADER.STATUS.AWAITCOLLECTION');
    }
  }
}
